import { uniq, sortBy } from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';
import { FollowUpFilterData } from '../../../components/pages/Followup/FilterContent';
import { RootState } from '../../store/store';
import data from '../../../sideEffects/company/settings/mockData';

const activeFiltersCount = createSelector(
    (state: RootState) => state.followUps.filterFields.length,
    (activeFiltersCount) => activeFiltersCount
);
const getFilterData = createSelector(
    (state: RootState) => state.followUps,
    (state) => {
        const { followUps } = state;
        const cargoOwners = followUps.map((item) => item.cargoOwner).filter((item) => item !== '');
        const shippers = followUps.map((item) => item.shipper).filter((item) => item !== '');
        const consignees = followUps.map((item) => item.consignee).filter((item) => item !== '');
        const containerNumbers = followUps.map((item) => item.containerNumber).filter((item) => item !== '' && item !== undefined);
        const awbs = followUps.map((item) => item.awb).filter((item) => item !== '' && item !== undefined);
        const states = data.en.state.map((item) => {
            return { value: item.code, text: item.name, isSelected: false };
        });
        const filterData: FollowUpFilterData = {
            cargoOwnerOptions: uniq(cargoOwners).map((item) => {
                return { value: item, text: item, isSelected: false };
            }),
            stateOptions: states,
            consigneeOptions: uniq(consignees).map((item) => {
                return { value: item, text: item, isSelected: false };
            }),
            shipperOptions: uniq(shippers).map((item) => {
                return { value: item, text: item, isSelected: false };
            }),
            containerNumberOptions: uniq(containerNumbers).map((item) => {
                return { value: item, text: item, isSelected: false };
            }),
            awbOptions: uniq(awbs).map((item) => {
                return { value: item, text: item, isSelected: false };
            })
        };
        return filterData;
    }
);

const filterFields = createSelector(
    (state: RootState) => state.followUps.filterFields,
    (filterFields) => {
        const filterFieldsData = filterFields.map((item) => {
            return { field: item.field, value: item.value };
        });
        console.log('filterFieldsData', filterFieldsData);
        return filterFieldsData;
    }
);
const filteredFollowUps = createSelector(
    (state: RootState) => state.followUps.followUps,
    (state: RootState) => state.followUps.filterFields,
    (followUps, filterFields) => {
        if (filterFields.length === 0) return followUps;

        // Extract date filters separately
        const fromDueDateFilter = filterFields.find((filter) => filter.field === 'fromDueDate');
        const toDueDateFilter = filterFields.find((filter) => filter.field === 'toDueDate');

        // Apply non-date filters first
        const nonDateFilters = filterFields.filter((filter) => filter.field !== 'fromDueDate' && filter.field !== 'toDueDate');

        let filteredItems = followUps;

        if (nonDateFilters.length > 0) {
            filteredItems = followUps.filter((item) => {
                let returnVal = false;
                nonDateFilters.forEach((filter) => {
                    if (returnVal) return;
                    if (filter.field === 'currentState') {
                        returnVal = filter.value.includes(item.state);
                    } else if (filter.field === 'previousState') {
                        returnVal = filter.value.includes(item.previousState);
                    } else if (filter.field === 'cargoOwner') {
                        returnVal = filter.value.includes(item.cargoOwner);
                    } else if (filter.field === 'shipper') {
                        returnVal = filter.value.includes(item.shipper);
                    } else if (filter.field === 'consignee') {
                        returnVal = filter.value.includes(item.consignee);
                    } else if (filter.field === 'containerNumber' && item.containerNumber) {
                        returnVal = filter.value.includes(item.containerNumber);
                    } else if (filter.field === 'awb' && item.awb) {
                        returnVal = filter.value.includes(item.awb);
                    } else if (filter.field === 'assignee') {
                        returnVal = filter.value.includes(item.assignedTo);
                    } else if (filter.field === 'trackingId' && item.trackingId) {
                        returnVal = filter.value.includes(item.trackingId);
                    } else if (filter.field === 'customsFile' && item.customsFile) {
                        returnVal = filter.value.includes(item.customsFile);
                    }
                });
                return returnVal;
            });
        }

        // Apply date range filters separately using moment
        if (fromDueDateFilter && fromDueDateFilter.value) {
            const fromDate = moment(fromDueDateFilter.value);
            filteredItems = filteredItems.filter((item) => {
                if (!item.dueDate) return false;
                const itemDueDate = moment(item.dueDate);
                return itemDueDate.isSameOrAfter(fromDate, 'day');
            });
        }

        if (toDueDateFilter && toDueDateFilter.value) {
            const toDate = moment(toDueDateFilter.value);
            filteredItems = filteredItems.filter((item) => {
                if (!item.dueDate) return false;
                const itemDueDate = moment(item.dueDate);
                return itemDueDate.isSameOrBefore(toDate, 'day');
            });
        }

        // Sort by due date in ascending order
        return sortBy(filteredItems, (item) => item.dueDate ? moment(item.dueDate).valueOf() : Infinity);
    }
);
const selectors = {
    getFilterData,
    activeFiltersCount,
    filterFields,
    filteredFollowUps
};
export default selectors;
